export class StringUtils {
    static Characters = {
        Empty: '',
        Space: ' ',
        Underline: '_',
        Slash: '/',
        Colon: ':',
        Semicolon: ';',
        Comma: ',',
        Period: '.',
        Pipe: '|'
    };

    static isEmpty(str: string | null | undefined): boolean {
        return !str || str.trim().length === 0;
    }

    /* Converts to a number, returning the defaultValue | null if conversion fails */
    static toNumber(value: string | string[] | null | undefined, defaultValue: number | null = null): number | null {
        const str = Array.isArray(value) ? value[0] : value;

        if (this.isEmpty(str)) {
            return defaultValue;
        }

        const num = Number(str);
        return Number.isNaN(num) ? defaultValue : num;
    }
}
